import { useSyncExternalStore } from 'react'

const MYMTS_SESSION_KEY = 'utmSource'

export const getIsMyMts = (): boolean => {
  if (typeof window === 'undefined') return false

  if (window.location.search.includes('utm_source=MM')) {
    sessionStorage.setItem(MYMTS_SESSION_KEY, 'true')

    return true
  }

  return sessionStorage.getItem(MYMTS_SESSION_KEY) === 'true'
}

const subscribe = () => () => {}

export const useIsMyMts = () => useSyncExternalStore(subscribe, getIsMyMts, () => false)
